export default __webpack_public_path__ + "static/media/dp-perfor-js.c42e5661.png";